import { makeStyles } from '@material-ui/styles';
import { white, saffronMango } from '../../constants/Colors';

export default makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: ({ isPublicMode }) => (isPublicMode ? 'fit-content' : '60px'),
        backgroundColor: white,
        position: ({ isMobile, isPublicMode }) => (isMobile || isPublicMode ? 'absolute' : 'fixed'),
        top: '0',
        left: '0',
        zIndex: ({ isManualQualifyPage }) => (isManualQualifyPage ? 1400 : 5),
        width: '100%',
        boxShadow: ({ hasSubheader }) => (hasSubheader ? '' : '0px 0px 6px rgba(38, 36, 51, 0.25)'),
    },
    strip: {
        width: '100%',
        height: '5px',
        backgroundColor: saffronMango,
    },
    body: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
    },
    leftSide: {
        display: 'flex',
        alignItems: 'center',
    },
    rightSide: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    userMenu: {
        display: 'flex',
        alignItems: 'center',
    },
    mediaLinks: {
        marginRight: 40,
    },
    marginLeft: {
        marginLeft: 50,
        marginTop: 11,
        marginBottom: 5,
    },
    publicLogo: {
        height: 50,
        display: 'flex',
        marginLeft: 10,
    },
}));
